export const categories = [
  {
    slug: 'kang-shuai-hu-fu',
    name: '抗衰护肤',
    description: '科学护肤方案，从清洁、保湿到抗氧化，全方位守护肌肤年轻态',
    icon: 'ri-shield-star-line',
    imageSeq: 'category-skincare',
    imageQuery: 'Minimalist%20skincare%20products%20arrangement%20with%20natural%20botanical%20ingredients%2C%20serum%20bottles%20and%20green%20leaves%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%20with%20gentle%20shadows',
  },
  {
    slug: 'yin-shi-yang-sheng',
    name: '饮食养生',
    description: '从餐桌开始抗衰老，抗氧化食材搭配、营养均衡方案，吃出年轻活力',
    icon: 'ri-bowl-line',
    imageSeq: 'category-diet',
    imageQuery: 'Fresh%20colorful%20antioxidant%20rich%20foods%20arranged%20beautifully%20on%20wooden%20table%2C%20berries%20nuts%20green%20vegetables%2C%20warm%20natural%20sunlight%2C%20healthy%20eating%20concept%2C%20minimalist%20food%20photography%20with%20soft%20shadows%20and%20neutral%20background',
  },
  {
    slug: 'yun-dong-jian-shen',
    name: '运动健身',
    description: '科学运动方案激活身体机能，提升代谢、增强肌肉、保持年轻体态',
    icon: 'ri-heart-pulse-line',
    imageSeq: 'category-fitness',
    imageQuery: 'Elegant%20yoga%20studio%20with%20natural%20morning%20light%20streaming%20through%20large%20windows%2C%20minimalist%20wooden%20floor%2C%20peaceful%20wellness%20atmosphere%2C%20soft%20cream%20walls%2C%20indoor%20plants%2C%20serene%20and%20clean%20aesthetic%20photography',
  },
  {
    slug: 'shui-mian-xiu-fu',
    name: '睡眠修复',
    description: '高质量睡眠是天然抗衰利器，科学作息调整帮你睡出好气色',
    icon: 'ri-moon-clear-line',
    imageSeq: 'category-sleep',
    imageQuery: 'Serene%20bedroom%20interior%20with%20soft%20linen%20bedding%2C%20gentle%20morning%20light%20through%20sheer%20curtains%2C%20minimalist%20decor%2C%20calm%20and%20peaceful%20atmosphere%2C%20warm%20neutral%20tones%2C%20cozy%20yet%20elegant%20interior%20photography',
  },
  {
    slug: 'xin-li-jian-kang',
    name: '心理健康',
    description: '情绪管理、压力释放、正念冥想，让心态年轻是抗衰的第一步',
    icon: 'ri-mental-health-line',
    imageSeq: 'category-mental',
    imageQuery: 'Peaceful%20meditation%20space%20with%20morning%20sunlight%2C%20minimalist%20interior%20with%20soft%20cushions%20and%20green%20plants%2C%20calm%20atmosphere%2C%20warm%20neutral%20palette%2C%20serene%20wellness%20photography%20with%20gentle%20shadows',
  },
  {
    slug: 'mei-rong-yi-liao',
    name: '美容医疗',
    description: '了解前沿医美技术与科学抗衰手段，理性选择适合自己的方案',
    icon: 'ri-syringe-line',
    imageSeq: 'category-medical',
    imageQuery: 'Modern%20clean%20medical%20aesthetic%20clinic%20interior%20with%20soft%20warm%20lighting%2C%20minimalist%20white%20and%20cream%20design%2C%20professional%20yet%20inviting%20atmosphere%2C%20fresh%20flowers%20on%20counter%2C%20elegant%20healthcare%20photography',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};